import { useState } from "react";
import { setFocus } from "@noriginmedia/norigin-spatial-navigation";
import { FIRST_EVENT_KEY } from "../constants/event";
import { trackPendoEvent } from "../utils/shared/pendo";
import { isConnected } from "../../Upshow";

export default function useEPGState(resetFilter, deeplinkEventIdUrl, orgShouldCheckToSignTC) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [focusKeyToReturn, setFocusKeyToReturn] = useState(null);
    const [deeplinkEventId, setDeeplinkEventId] = useState(deeplinkEventIdUrl);
    const shouldSignXumoTC = window.__UpshowState && !!window.__UpshowState.xumoTermsAndConditions?.shouldSign;
    const [showTermsPopup, setShowTermsPopup] = useState(false);


    const openEPG = () => {
        if (!isConnected()) return;

        if (orgShouldCheckToSignTC) {
            if (!shouldSignXumoTC) {
                setIsOpen(true);
            }else {
                setShowTermsPopup(true);
            }
        }
        else {
            setIsOpen(true);
        }

        // Pendo tracking
        trackPendoEvent('Open EPG');
    };

    const closeEPG = () => {
        // Reset all states
        setIsOpen(false);
        setSelectedEvent(null);
        setFocusKeyToReturn(null);
        resetFilter();
        setFocus(FIRST_EVENT_KEY);
        setDeeplinkEventId(null);
        setShowTermsPopup(false);

        // Pendo tracking
        trackPendoEvent('Close EPG');
    };

    const clearSelection = () => {
        setSelectedEvent(null);

        if (focusKeyToReturn) {
            setFocus(focusKeyToReturn);
        }
        setFocusKeyToReturn(null);
        setDeeplinkEventId(null);
    };

    return {
        isOpen,
        selectedEvent,
        focusKeyToReturn,
        deeplinkEventId,
        shouldSignXumoTC,
        showTermsPopup,
        setShowTermsPopup,
        openEPG,
        closeEPG,
        clearSelection,
        setSelectedEvent,
        setFocusKeyToReturn,
    };
}
